export default __webpack_public_path__ + "media/images/screenshot-09323590b4d8c05ec2037990998d61db.jpg";